import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h2>This is our inventory</h2>
        </div>
    );
};

export default Inventory;